import React from 'react'
import { isMobile, isTablet } from "react-device-detect"
import RtceDisplay from './RtceDisplay';

const EirReasonsToChooseEir = (props) => {
    if (!isMobile && props.display === 'desktop-only') {
        return (
            <RtceDisplay rtce={props} />
        )
    } else if (isMobile && props.display === 'mobile-only') {
        return (
            <RtceDisplay rtce={props} />
        )
    } else if (isTablet && (props.display === 'mobile-only' || props.display === 'desktop-only')) {
        return (
            <RtceDisplay rtce={props} />
        )
    } else if (props.display === 'both') {
        return (
            <RtceDisplay rtce={props} />
        )
    } else {
        return <div></div>
    }
}

export default EirReasonsToChooseEir
